import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/conversion-quantity-unit";

export const getConversionQuantityUnitById = (conversionQuantityUnitId) => axios.get(API_PATH + "/getbyid/" + conversionQuantityUnitId)

export const deleteConversionQuantityUnit = conversionQuantityUnitId => axios.delete(API_PATH + '/mark-delete/' + conversionQuantityUnitId);

export const saveConversionQuantityUnit = (searchObject) => axios.post(API_PATH + "/save-or-update", searchObject);

export const pagingConversionQuantityUnit = searchConversionQuantityUnit => axios.post(API_PATH + "/search-by-page", searchConversionQuantityUnit);